// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo[data-v-d5f9efb8] {
  display: none;
}
.logo.light[data-v-d5f9efb8] {
  display: block;
}
.ion-palette-dark .logo.light[data-v-d5f9efb8] {
  display: none;
}
.ion-palette-dark .logo.dark[data-v-d5f9efb8] {
  display: block;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
